exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.offices-information-page[data-v-c0ecf788]{height:100%}div.content[data-v-c0ecf788]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}.filler[data-v-c0ecf788]{position:absolute;width:100%;height:100%;top:0;left:0;z-index:1}a[data-v-c0ecf788]{text-decoration:none}a[data-v-c0ecf788]:hover{color:#0c2340}", ""]);

// exports
